import { Module } from 'vuex';
import { rootState } from '../state';
import { SettlementAccounts } from '@/types/settlement-account'
import { $fetch } from '@/api/fetch';
import REQ_URL from '@/consts/req-url';
const state = {
    settlementAccounts: [] as SettlementAccounts
}

export const regionStore: Module<typeof state, typeof rootState> = {
    state,
    mutations: {
        setSettlementAccounts(state, sa: SettlementAccounts) {
            state.settlementAccounts = sa
        }
    },
    actions: {
        async setSettlementAccounts(c) {
            try {
                let data = await $fetch<SettlementAccounts>(REQ_URL.GET_SETT_ACC)
                if (data.body) c.commit('setSettlementAccounts', data.body)
            } catch (error) {
                console.error(error)
            }
        }
    },
    getters: {
        settlementAccounts(state) {
            return state.settlementAccounts
        }
    }
}